import { Component } from '@angular/core';

@Component({
  selector: 'registry',
  templateUrl: './registry.component.html',
  styleUrls: ['./registry.component.css']
})
export class RegistryComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/registry/registry.component.ts